/* eslint-disable */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';
import { AppWrap, MotionWrap } from '../../wrapper';
import { experiences as experiencesData } from '../../data/portfolio';
import './Experience.scss';
import 'react-popper-tooltip/dist/styles.css';

const Experience = () => {
  const [experiences, setExperiences] = useState([]);

  useEffect(() => {
    setExperiences(experiencesData);
  }, []);

  return (
    <>
      <h2 className="head-text">Experience <span>Highlights</span></h2>
      <div className="app__experience-container">
        <div className="app__experience-list">
          {experiences.map((experience) => (
            <motion.div
              className="app__experience-item"
              key={experience.year}
            >
              <div className="app__experience-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__experience-works">
                {experience.works.map((work) => (
                  <motion.div
                    whileInView={{ opacity: [0, 1] }}
                    transition={{ duration: 0.5 }}
                    className="app__experience-work"
                    data-tip
                    data-for={work.name}
                    key={work.name}
                  >
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <h4 className="bold-text">{work.name}</h4>
                    </div>
                    <p className="p-text">{work.company}</p>
                    {work.desc && <p className="p-text-desc">{work.desc}</p>}
                    {work.deliverables && work.deliverables.length > 0 && (
                      <ul className="experience-deliverables">
                        {work.deliverables.map((deliverable, index) => (
                          <li key={index}>{deliverable}</li>
                        ))}
                      </ul>
                    )}
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Experience, 'app__experience'),
  'experience',
  'app__whitebg',
);
